'use strict';

export function stripeElementsConfig(StripeElementsProvider, PLATFORM_CONFIG) {
  'ngInject';

  if (PLATFORM_CONFIG.data.stripe && PLATFORM_CONFIG.data.stripe.apiKey) {
    StripeElementsProvider.setAPIKey(PLATFORM_CONFIG.data.stripe.apiKey);
  }
}

export function routeConfig($urlRouterProvider, $locationProvider) {
  'ngInject';

  $urlRouterProvider.otherwise('/');

  $locationProvider.html5Mode(true);
}

export function themeConfig(PLATFORM_CONFIG, APP_CONFIG, CUSTOM_STYLES) {
  'ngInject';

  var theme = PLATFORM_CONFIG.data.theme || 'cerulean';
  var backgroundUrl = PLATFORM_CONFIG.data.background || '/assets/images/background.jpg';

  jQuery('head title').text(APP_CONFIG.data.moduleConfig["general"].clientName);

  jQuery("body").css('background-image', 'url(' + backgroundUrl + ')');

  jQuery('head').append('<link rel="stylesheet" href="assets/libs/bootswatch/'+theme+'.bootstrap.min.css" type="text/css" />');

  jQuery('head').append("<style type='text/css'>"+CUSTOM_STYLES.data.css+"</style>");
}

export function accessibilityWidgetConfig(PLATFORM_CONFIG) {
  'ngInject';

  var userwayConfig = PLATFORM_CONFIG.data.accessibilityWidgetConfig;

  if (userwayConfig && userwayConfig.account) {
    jQuery('body').append("<script type='text/javascript'> var _userway_config = "+ JSON.stringify(userwayConfig) +"</script>");
    jQuery('body').append('<script type="text/javascript" src="https://cdn.userway.org/widget.js"></script>');
  }
}

export function decorateTextAngular($provide){
  'ngInject';

  $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', function(taRegisterTool, taOptions, $uibModal){

    taRegisterTool('backgroundColor', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
      "<button title='Background Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:black; background-color:yellow'>ABC</span><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, color) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('backColor', color);
      },
      options: [
        { name: 'Aqua', css: "aqua" },
        { name: 'Black', css: "black" },
        { name: 'Blue', css: "blue" },
        { name: 'Fuchsia', css: "fuchsia" },
        { name: 'Gray', css: "gray" },
        { name: 'Green', css: "green" },
        { name: 'Lime', css: "lime" },
        { name: 'Maroon', css: "maroon" },
        { name: 'Navy', css: "navy" },
        { name: 'Olive', css: "olive" },
        { name: 'Purple', css: "purple" },
        { name: 'Red', css: "red" },
        { name: 'Silver', css: "silver" },
        { name: 'Teal', css: "teal" },
        { name: 'White', css: "white" },
        { name: 'Yellow', css: "yellow" }
      ]
    });

    taRegisterTool('fontColor', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
      "<button title='Text Color' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><span style='color:red'>A</span><span style='color:green'>B</span><span style='color:blue'>C</span><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='width: 100%' type='button' ng-click='action($event, o.css)'><div style='border:1px solid black; float:left; width:20px; background-color: {{o.css}}; '>&nbsp;</div>&nbsp;&nbsp;<i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, color) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('foreColor', color);
      },
      options: [
        { name: 'Aqua', css: "aqua" },
        { name: 'Black', css: "black" },
        { name: 'Blue', css: "blue" },
        { name: 'Fuchsia', css: "fuchsia" },
        { name: 'Gray', css: "gray" },
        { name: 'Green', css: "green" },
        { name: 'Lime', css: "lime" },
        { name: 'Maroon', css: "maroon" },
        { name: 'Navy', css: "navy" },
        { name: 'Olive', css: "olive" },
        { name: 'Purple', css: "purple" },
        { name: 'Red', css: "red" },
        { name: 'Silver', css: "silver" },
        { name: 'Teal', css: "teal" },
        { name: 'White', css: "white" },
        { name: 'Yellow', css: "yellow" }
      ]
    });

    taRegisterTool('fontName', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px;'>" +
      "<button title='Font Face' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-font'></i><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-family: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.css)'><i ng-if='o.active' class='fa fa-check'></i>{{o.name}}</a></li></ul></span>",
      action: function (event, font) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('fontName', font);
      },
      options: [
        { name: 'Sans-Serif', css: 'Arial, Helvetica, sans-serif' },
        { name: 'Serif', css: "'times new roman', serif" },
        { name: 'Wide', css: "'arial black', sans-serif" },
        { name: 'Narrow', css: "'arial narrow', sans-serif" },
        { name: 'Comic Sans MS', css: "'comic sans ms', sans-serif" },
        { name: 'Courier New', css: "'courier new', monospace" },
        { name: 'Garamond', css: 'garamond, serif' },
        { name: 'Georgia', css: 'georgia, serif' },
        { name: 'Tahoma', css: 'tahoma, sans-serif' },
        { name: 'Trebuchet MS', css: "'trebuchet ms', sans-serif" },
        { name: "Helvetica", css: "'Helvetica Neue', Helvetica, Arial, sans-serif" },
        { name: 'Verdana', css: 'verdana, sans-serif' },
        { name: 'Proxima Nova', css: 'proxima_nova_rgregular' }
      ]
    });

    taRegisterTool('fontSize', {
      display: "<span class='bar-btn-dropdown dropdown' style='padding:0px'>" +
      "<button title='Font Size' class='btn dropdown-toggle' type='button' ng-disabled='showHtml()' style='background-color: transparent; border: transparent; padding-top: 8px 12px'><i class='fa fa-text-height'></i><i class='fa fa-caret-down'></i></button>" +
      "<ul class='dropdown-menu'><li ng-repeat='o in options'><a class='checked-dropdown' style='font-size: {{o.css}}; width: 100%' type='button' ng-click='action($event, o.value)'><i ng-if='o.active' class='fa fa-check'></i> {{o.name}}</a></li></ul>" +
      "</span>",
      action: function (event, size) {
        //Ask if event is really an event.
        if (!!event.stopPropagation) {
          //With this, you stop the event of textAngular.
          event.stopPropagation();
          //Then click in the body to close the dropdown.
          $("body").trigger("click");
        }
        return this.$editor().wrapSelection('fontSize', parseInt(size));
      },
      options: [
        { name: 'XX Small', css: 'xx-small', value: 1 },
        { name: 'X Small', css: 'x-small', value: 2 },
        { name: 'Small', css: 'small', value: 3 },
        { name: 'Medium', css: 'medium', value: 4 },
        { name: 'Large', css: 'large', value: 5 },
        { name: 'X Large', css: 'x-large', value: 6 },
        { name: 'XX Large', css: 'xx-large', value: 7 }

      ]
    });

    taRegisterTool('codeMirror', {
      iconclass: "fa fa-code",
      disabled: function() {return false},
      action: function(){
        var modalInstance = $uibModal.open({
          animation: true,
          component: 'codemirrorHtmlForm',
          backdrop: "static",
          windowClass: 'html-modal',
          resolve: {
            config: () => {
              return {
                data: this.$editor().html
              }
            }
          },
          size: 'lg'
        });

        modalInstance.result.then(
          (html) => {
            this.$editor().html = html;
          },
          function () { /* cancel */ }
        );
      }
    });

    taRegisterTool('archiveImageLink', {
      iconclass: "fa fa-archive",
      disabled: function() {return false},
      action: function(){
        var modalInstance = $uibModal.open({
          animation: true,
          component: 'assetBrowser',
          backdrop: "static",
//          windowClass: 'html-modal',
          resolve: {
            config: () => {
              return {
                restrictToFileTypes: ["image/jpeg", "image/png"]
              }
            }
          },
          size: 'lg'
        });

        modalInstance.result.then(
          (selectedImages) => {

            selectedImages.forEach(selectedImage => {
              //var embed = '<img src="/api/storage/' + selectedImage._id + '">';
              //return this.$editor().wrapSelection('insertHTML', embed, true);

              let url = (selectedImage.isPublic)
                  ? "/api/storage/public/" + selectedImage._id
                  : "/api/storage/" + selectedImage._id;

              this.$editor().wrapSelection('insertImage', url, true);

            });
          },
          function () { /* cancel */ }
        );
      }
    });

    // add the button to the default toolbar definition
    //taOptions.toolbar[1].push('backgroundColor','fontColor','fontName','fontSize');
    return taOptions;
  }]);
}


export function addSingleFileUploadCache($templateCache) {
  'ngInject';
  
  $templateCache.put("components/schema-form-single-file-upload/single-file-upload.html",
    `<div class="form-group" ng-class="{'has-error': hasError(), 'has-success': hasSuccess(), 'has-feedback': form.feedback !== false }\"> <!-- Surrounding DIV for sfField builder to add a sfField directive to. -->
    <label>{{form.title}}</label>
        
      <div ng-if="model[form.key[0]]">
        <div class="well well-sm">
            <a ng-href="/api/storage/{{model[form.key[0]]}}" target="_blank"><i class="fa fa-fw fa-download"></i> Download</a>
            <a class="btn btn-sm btn-danger pull-right" style="position: relative; top: -5px;"
                ng-click="model[form.key[0]] = undefined"><i class="fa fa-fw fa-trash"></i></a>
        </div>
      </div>
  
      <div ng-if="!model[form.key[0]]">
        <a class="btn btn-sm btn-primary" ng-click="form.schema.fnOpenAssetUploadModal(form.key[0])"><i class="fa fa-fw fa-upload"></i> Upload</a>
      </div>
      
    <div sf-message="form.description"></div>
</div>`);

}

export function schemaFormSingleFileUpload(schemaFormDecoratorsProvider, sfBuilderProvider) {
  'ngInject';

  schemaFormDecoratorsProvider.defineAddOn(
    'bootstrapDecorator',         // Name of the decorator you want to add to.
    'single-file-upload',                    // Form type that should render this add-on
    'components/schema-form-single-file-upload/single-file-upload.html',    // Template name in $templateCache
    sfBuilderProvider.stdBuilders // List of builder functions to apply.
  );
}


// WEBPACK FOOTER //
// ./client/app/app.config.js